<template>
  <v-container fluid>
    <efectivity class="mb-5"/> 
    <daily-load class="mb-5"/> 
    <!-- <total-day class="mb-5"/>
    -->
    <v-layout row wrap mt-1>
      <v-flex lg12>
        <info-schedules :date="date2"></info-schedules>
      </v-flex>
    </v-layout>
    <!--
    <v-layout row wrap mt-4>
      <v-flex lg12>
        <contactability :date="date2"></contactability>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4>
      <v-flex lg12>
        <payments></payments>
      </v-flex>
    </v-layout>
    -->
    <v-layout row wrap mt-4>
      <v-flex lg12>
        <management :date="date1"></management>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4>
      <v-flex md12>
        <schedules :date="date1"></schedules>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4>
      <v-flex lg12>
        <customer-schedules :date="date1"></customer-schedules>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap mt-4>
      <v-flex md12>
        <payments-graphic></payments-graphic>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4>
      <v-flex md12>
        <tables-tr></tables-tr>
      </v-flex>
    </v-layout> -->
    <v-dialog
      v-model="downloadReport.dialog"
      scrollable
      persistent
      max-width="900px"
      transition="dialog-transition"
    >
      <template v-if="downloadReport.dialog">
        <v-card>
          <v-layout justify-center align-center class="k-orange-linear">
            <v-flex md9 class="pl-2 py-3 f1-5em white--text">
              {{downloadReport.title}}
            </v-flex>
            <v-flex md3 class="text-xs-right pr-2">
              <v-btn color="white" outline flat @click="generateReport(downloadReport.filters, downloadReport.functionName)">
                DESCARGAR 
                <v-icon small class="pl-2">fas fa-download</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-card-text>
            <data-table
            :url="downloadReport.url"
            :content="downloadReport.content"
            :filters="downloadReport.filters"
            :limit="6"
            :apply-url-filters="false">
            </data-table>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap>
              <v-flex md12 class="text-xs-right">
                <v-btn flat @click="downloadReport.dialog = false">CERRAR</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import EventBus from '@/event-bus';
import contactability from '@/components/panel/contactability/Index';
import Management from '@/components/panel/management/Index';
import infoSchedules from '@/components/panel/info_schedules/Index';
import customerSchedules from '@/components/panel/customer_schedules/Index';
import paymentSmy from '@/components/panel/payment_smy/Index';
import dataTable from '@/components/global/DataTable';
import customerStatusList from '@/components/global/report_datatables/CustomerStatusList';
import paymentsGraphic from '@/components/payment/PaymentGraphic';
import schedules from '@/components/panel/schedules/Index';
import tablesTr from '@/components/panel/TablesTr';
import payments from '@/components/panel/payment_smy/PaymentReport';
import Efectivity from './efectivity/EfectivityGraphics';
import DailyLoad from './daily_load/DailyLoad';
import TotalDay from './total_day/Total';

Vue.component('customerStatusList', customerStatusList);

export default {
  mounted() {
    /* this.axios.get('worker/notifications/1/time').then((response) => {
      this.date1 = moment.utc(response.data.date).local().format('DD/MM/YYYY hh:mm a');
    });
    this.axios.get('worker/dashboard/time').then((response) => {
      this.date2 = moment.utc(response.data.date).local().format('DD/MM/YYYY hh:mm a');
    }); */
  },

  created() {
    EventBus.$on('downloadReport', (title, url, content, filters, functionName) => {
      if (moment().format('YYYY-MM-DD') === filters.date) {
        this.downloadReport.title = title;
        this.downloadReport.url = url;
        this.downloadReport.content = content;
        this.downloadReport.filters = filters;
        this.downloadReport.functionName = functionName;
        this.downloadReport.dialog = true;
      } else {
        EventBus.$emit('infoModal', 'Para descargar reportes debe seleccionar la fecha actual', 'fas fa-info-circle');
      }
    });
  },
  components: {
    contactability,
    infoSchedules,
    Management,
    customerSchedules,
    paymentSmy,
    paymentsGraphic,
    tablesTr,
    schedules,
    Efectivity,
    DailyLoad,
    TotalDay,
    dataTable,
    payments,
  },
  data() {
    return {
      downloadReport: {
        url: '',
        title: '',
        dialog: false,
        content: '',
        filters: {},
        functionName: '',
      },
      date1: '',
      date2: '',
    };
  },
  methods: {
    generateReport(filters, functionName) {
      EventBus.$emit('startListenEvent');
      const data = {
        filters,
        functionName,
      };
      this.axios.post('/reports', data).then(() => {
        EventBus.$emit('infoModal',
          'Se esta generando su archivo, se le informara cuando este listo el reporte, por favor espere.',
          'fas fa-check-double');
      });
    },
  },
};
</script>

<style>
.gray-bar {
  stroke: #e6e6e6;
}

hr.centered {
  margin-left: 25%;
  margin-right: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/panel/Index.vue